module.exports = __webpack_public_path__ + "assets/img/a20cd494f490a403136125ec10875b95.svg";